import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CardAreaModule } from '@app/my-booking/sub-components/card-area/card-area.module';
import { MyBookingInforModule } from '@app/my-booking/sub-components/information/my-booking-infor.module';
import { MyBookingTabsModule } from '@app/my-booking/sub-components/tab/my-booking-tabs.module';
import { NextActionModule } from '@common/components/next-action/next-action.module';
import { GetOrderStoreModule } from '@common/store/get-order';
import { ButtonModule } from '@lib/components';
import { StaticMsgModule } from '@lib/pipes';
import { DialogDisplayServiceModule } from '@lib/services';
import { AswMasterStoreModule } from '@lib/store';
import { MyBookingItineraryContModule } from '../sub-components/my-booking-itinerary/container/my-booking-itinerary-cont.module';
import { MyBookingPassengerContModule } from '../sub-components/my-booking-passenger/container/my-booking-passenger-cont.module';
import { MyBookingServicesModule } from '../sub-components/my-booking-service/container/my-booking-services.module';
import { MyBookingPresComponent } from './my-booking-pres.component';
import { TealiumModule } from '@common/components/tealium/tealium.module';

@NgModule({
  declarations: [MyBookingPresComponent],
  imports: [
    CommonModule,
    MyBookingInforModule,
    NextActionModule,
    ButtonModule,
    StaticMsgModule,
    AswMasterStoreModule,
    DialogDisplayServiceModule,
    CardAreaModule,
    MyBookingTabsModule,
    GetOrderStoreModule,
    MyBookingServicesModule,
    MyBookingItineraryContModule,
    MyBookingPassengerContModule,
    TealiumModule,
  ],
  exports: [MyBookingPresComponent],
})
export class MyBookingPresModule {}
